/* global axios */
import ApiClient from './ApiClient';

class AiMassiva extends ApiClient {
  constructor() {
    super('ai/massiva', { accountScoped: true });
  }

  // GET /ai/massiva → { provider, provider_name, supported, instances: [{ label,
  // system_label, host, snapshot: { health, generated_at, ... } | null,
  // snapshot_written_at }] }
  // `provider_name` = nome humano do catálogo (IXCSoft, SGP (TSMX)...) — o
  // painel mostra o slug cru se faltar (degradação visível, não silenciosa).
  // SÓ-LEITURA: serve sempre o último retrato do produtor (stream) com a
  // idade carimbada — nunca computa, nunca espera ERP. Instância sem retrato
  // volta snapshot nulo, divulgado.
  get() {
    return axios.get(this.url);
  }

  // POST /ai/massiva/refresh → 202 { requested: N }
  // Pede um ciclo PRIORITÁRIO ao produtor (MCP); o retrato novo chega pelo
  // broadcast `snapshot_written` de sempre. requested: 0 = conta sem
  // instância no produtor (massiva não habilitado) — o front avisa.
  requestRefresh() {
    return axios.post(`${this.url}/refresh`);
  }
}

export default new AiMassiva();
